<template>
  <div class="right-overview">
    <!-- Header -->
    <div class="overview-header">
      <h2 class="header-title">{{ $t('home.dashboard.view_history_trace') }}</h2>
    </div>

    <!-- Stat Cards 2x2 -->
    <div class="stat-grid">
      <div class="stat-card stat-card--cyan">
        <div class="stat-card__icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M2 12h4l3-9 4 18 3-9h4" />
          </svg>
        </div>
        <div class="stat-card__info">
          <span class="stat-card__value">{{ stats.online }}</span>
          <span class="stat-card__label">{{ $t('home.dashboard.online_devices') }}</span>
        </div>
      </div>

      <div class="stat-card stat-card--amber">
        <div class="stat-card__icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        <div class="stat-card__info">
          <span class="stat-card__value">{{ stats.warning }}</span>
          <span class="stat-card__label">{{ $t('home.dashboard.warning_devices') }}</span>
        </div>
      </div>

      <div class="stat-card stat-card--red">
        <div class="stat-card__icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
        </div>
        <div class="stat-card__info">
          <span class="stat-card__value">{{ stats.danger }}</span>
          <span class="stat-card__label">{{ $t('home.dashboard.danger_devices') }}</span>
        </div>
      </div>

      <div class="stat-card stat-card--green">
        <div class="stat-card__icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="1" y="3" width="15" height="13" />
            <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
            <circle cx="5.5" cy="18.5" r="2.5" />
            <circle cx="18.5" cy="18.5" r="2.5" />
          </svg>
        </div>
        <div class="stat-card__info">
          <span class="stat-card__value">{{ stats.vehicles }}</span>
          <span class="stat-card__label">{{ $t('home.dashboard.vehicles') }}</span>
        </div>
      </div>
    </div>

    <!-- Alert Section -->
    <div class="alert-section">
      <h3 class="section-title">{{ $t('map.recentEvents') }}</h3>
      <div class="alerts-list" v-if="alerts.length">
        <div
          class="alert-item"
          :class="alert.borderClass"
          v-for="alert in alerts"
          :key="alert.id"
        >
          <div class="alert-item__head">
            <span class="alert-item__title">{{ alert.titleI18nKey ? $t('home.dashboard.' + alert.titleI18nKey) : '' }}</span>
            <span class="alert-item__time">{{ formatAlertTime(alert.time) }}</span>
          </div>
          <p class="alert-item__desc">{{ alert.carrierName + ' ' + (alert.descI18nKey ? $t('home.dashboard.' + alert.descI18nKey) : '') }}</p>
        </div>
      </div>
      <div class="alert-empty" v-else>
        <span>{{ $t('map.noAlerts') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getDeviceStatus, getRecentAlerts } from '@/api/modules/home.js'

export default {
  name: 'RightOverview',

  data () {
    return {
      stats: {
        online: 0,
        warning: 0,
        danger: 0,
        vehicles: 0
      },
      avgTemp: 0,
      avgHumidity: 0,
      alerts: [],
      activeNodeName: 'All Nodes'
    }
  },

  computed: {

  },

  methods: {
    loadDeviceStatus () {
      getDeviceStatus().then(function (res) {
        if (res && res.result) {
          var result = res.result
          this.stats.online = result.onlineCount || 0
          this.stats.warning = result.abnormalCount || 0
          this.stats.danger = result.offlineCount || 0
        }
      }.bind(this)).catch(function (err) {
        console.error('[RightOverview] loadDeviceStatus error:', err)
      })
    },

    loadAlerts () {
      getRecentAlerts().then(function (res) {
        if (res && res.result) {
          this.alerts = res.result.map(function (item, index) {
            return {
              id: item.id || index + 1,
              titleI18nKey: item.exCatalog === 0 ? 'device_offline' :
                (item.exCatalog === 2 ? 'device_power_outage' :
                  (item.exType === 2 ? 'temperature_alert' : item.exType === 3 ? 'humidity_alert' : '')),
              time: item.happenTime,
              descI18nKey: item.exCatalog === 0 ? 'lost_connection' : item.exCatalog === 1 ? 'exceeded_threshold' : 'power_outage',
              carrierName: item.carrierName || '',
              borderClass: this.getAlertBorderClass(item.exCatalog)
            }
          }.bind(this))
        }
      }.bind(this)).catch(function (err) {
        console.error('[RightOverview] loadAlerts error:', err)
      })
    },

    getAlertBorderClass (index) {
      var classes = ['border-red', 'border-orange', 'border-blue']
      return classes[index % classes.length]
    },

    formatAlertTime (timestamp) {
      if (!timestamp) return '--'
      var now = Date.now()
      var diff = now - new Date(timestamp).getTime()
      if (diff < 0) return this.$t('home.dashboard.just_now')
      var seconds = Math.floor(diff / 1000)
      if (seconds < 60) return seconds + this.$t('home.dashboard.s_ago')
      var minutes = Math.floor(seconds / 60)
      if (minutes < 60) return minutes + this.$t('home.dashboard.m_ago')
      var hours = Math.floor(minutes / 60)
      if (hours < 24) return hours + this.$t('home.dashboard.h_ago')
      var days = Math.floor(hours / 24)
      return days + this.$t('home.dashboard.d_ago')
    },

    refreshData () {
      this.loadDeviceStatus()
      this.loadAlerts()
    }
  },

  mounted () {
    this.refreshData()
  }
}
</script>

<style scoped lang="scss">
$bg-white: #ffffff;
$bg-gray-50: #f9fafb;
$bg-gray-100: #f3f4f6;
$bg-gray-200: #e5e7eb;
$border-color: #e5e7eb;
$text-900: #111827;
$text-800: #1f2937;
$text-700: #374151;
$text-600: #4b5563;
$text-500: #6b7280;
$text-400: #9ca3af;
$text-300: #475569;
$accent: #3b82f6;
$success: #10b981;
$warning: #f59e0b;
$danger: #ef4444;
$info: #60a5fa;
$orange: #f97316;
$radius: 8px;
$radius-sm: 4px;
$radius-lg: 12px;

// Colors for alert borders
$color-red-500: #ef4444;
$color-orange-500: #f97316;
$color-blue-500: #3b82f6;
$color-yellow-500: #f59e0b;

// Background colors for alerts
$bg-red-50: #fef2f2;
$bg-orange-50: #fff7ed;
$bg-blue-50: #eff6ff;
$bg-yellow-50: #fefce8;

.right-overview {
  width: 100%;
  height: 100%;
  background: $bg-white;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 16px;
  box-sizing: border-box;
  gap: 20px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: $bg-gray-200;
    border-radius: 999px;
  }
}

/* Header */
.overview-header {
  padding-bottom: 16px;
  border-bottom: 1px solid $border-color;
}

.header-title {
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 600;
  color: $text-900;
  letter-spacing: 0.5px;
}

.header-subtitle {
  margin: 0;
  font-size: 12px;
  color: $text-400;
}

/* Section Title */
.section-title {
  margin: 0 0 12px 0;
  font-size: 13px;
  font-weight: 600;
  color: $text-500;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

/* Stat Cards Grid */
.stat-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.stat-card {
  position: relative;
  background: $bg-gray-50;
  border-radius: $radius;
  padding: 14px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: hidden;
  border: 1px solid $border-color;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    border-radius: $radius $radius 0 0;
  }

  &--cyan::before {
    background: $accent;
  }

  &--amber::before {
    background: $warning;
  }

  &--red::before {
    background: $danger;
  }

  &--green::before {
    background: $success;
  }
}

.stat-card__icon {
  width: 36px;
  height: 36px;
  border-radius: $radius;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
  }

  .stat-card--cyan & {
    background: rgba(59, 130, 246, 0.1);
    color: $accent;
  }

  .stat-card--amber & {
    background: rgba(245, 158, 11, 0.1);
    color: $warning;
  }

  .stat-card--red & {
    background: rgba(239, 68, 68, 0.1);
    color: $danger;
  }

  .stat-card--green & {
    background: rgba(16, 185, 129, 0.1);
    color: $success;
  }
}

.stat-card__info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.stat-card__value {
  font-size: 20px;
  font-weight: 700;
  color: $text-900;
  line-height: 1.2;
}

.stat-card__label {
  font-size: 11px;
  color: $text-400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Gauge Section */
.gauge-section {
  padding-bottom: 16px;
  border-bottom: 1px solid $border-color;
}

.gauge-row {
  display: flex;
  justify-content: space-around;
  gap: 16px;
}

.gauge-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 110px;
}

.gauge-svg {
  width: 110px;
  height: 110px;
}

.gauge-track {
  stroke: $bg-gray-200;
}

.gauge-fill {
  transition: stroke-dasharray 0.6s ease;

  &--temp {
    stroke: $accent;
  }

  &--humidity {
    stroke: $info;
  }
}

.gauge-center {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 2px;
}

.gauge-value {
  font-size: 22px;
  font-weight: 700;
  color: $text-900;
  line-height: 1;
}

.gauge-unit {
  font-size: 11px;
  color: $text-400;
}

.gauge-label {
  margin-top: 6px;
  font-size: 11px;
  color: $text-500;
  text-align: center;
}

/* Alert Section */
.alert-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.alerts-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: $bg-gray-200;
    border-radius: 999px;
  }
}

.alert-item {
  padding: 12px;
  border-left: 4px solid;
  border-radius: 0 $radius-sm $radius-sm 0;
  background: $bg-gray-50;

  &.border-red {
    border-left-color: $color-red-500;
    background: $bg-red-50;
  }

  &.border-yellow {
    border-left-color: $color-yellow-500;
    background: $bg-yellow-50;
  }

  &.border-orange {
    border-left-color: $color-orange-500;
    background: $bg-orange-50;
  }

  &.border-blue {
    border-left-color: $color-blue-500;
    background: $bg-blue-50;
  }

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    font-size: 14px;
    font-weight: 500;
    color: $text-800;
  }

  &__time {
    font-size: 12px;
    color: $text-500;
  }

  &__desc {
    font-size: 12px;
    color: $text-600;
    margin: 4px 0 0;
  }
}

.alert-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-size: 12px;
  color: $text-400;
}
</style>
